import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import { useWallet } from '../context/WalletContext';
import SunIllustration from '../components/SunIllustration';
import QuestCard from '../components/QuestCard';

const INITIAL_QUESTS = [
  { id: '1', name: "Take today's medications", current: 0, total: 2, icon: 'medkit', done: false },
  { id: '2', name: 'Do 2 self-care Tasks', current: 0, total: 2, icon: 'cafe', done: false },
  { id: '3', name: 'Do 3 wellness Tasks', current: 0, total: 3, icon: 'leaf', done: false },
];

export default function QuestsScreen({ navigation }) {
  var questState = useState(INITIAL_QUESTS);
  var quests = questState[0];
  var setQuests = questState[1];
  var { addReward } = useWallet();

  var allDone = quests.every(function(q) { return q.done; });

  function advanceQuest(id) {
    setQuests(function(prev) {
      return prev.map(function(q) {
        if (q.id !== id || q.done) return q;
        var next = q.current + 1;
        return Object.assign({}, q, { current: next, done: next >= q.total });
      });
    });
  }

  var progressPct = (quests.filter(function(q) { return q.done; }).length / quests.length) * 100;

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.safe} edges={['top']}>
        <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
          {/* Date bar */}
          <View style={styles.dateRow}>
            <Text style={styles.dateText}>Fri, Jan.24th</Text>
            <View style={styles.iconRow}>
              <Icon name="mail-outline" size={20} color={Colors.textMid} />
              <Icon name="notifications-outline" size={20} color={Colors.textMid} />
            </View>
          </View>

          {/* Hero illustration with progress */}
          <View style={styles.hero}>
            <View style={styles.heroContent}>
              <View style={styles.progressPill}>
                <Text style={styles.progressArrow}>›</Text>
              </View>
              <View style={styles.progressBar}>
                <View style={[styles.progressFill, { width: progressPct + '%' }]} />
              </View>
            </View>
            <View style={styles.heroIllustration}>
              <SunIllustration size={85} />
              <View style={styles.giftBadge}>
                <Icon name="gift" size={24} color={Colors.primary} />
              </View>
            </View>
          </View>

          {/* Quest List */}
          <View style={styles.questSection}>
            <Text style={styles.questTitle}>Daily Quests</Text>
            <Text style={styles.questSubtitle}>complete each for a Reward</Text>

            {quests.map(function(quest) {
              return (
                <QuestCard
                  key={quest.id}
                  quest={quest}
                  onAdvance={function() { advanceQuest(quest.id); }}
                />
              );
            })}

            {allDone && (
              <TouchableOpacity
                style={styles.claimButton}
                onPress={function() { navigation.navigate('Spinner'); }}
              >
                <Text style={styles.claimButtonText}>🎁 Claim Reward</Text>
              </TouchableOpacity>
            )}
          </View>

          <View style={{ height: 20 }} />
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  scrollContent: { paddingBottom: 100 },
  dateRow: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 20, paddingTop: 8 },
  dateText: { fontSize: 13, color: Colors.textMid },
  iconRow: { flexDirection: 'row', gap: 8 },
  hero: {
    marginHorizontal: 20,
    marginTop: 8,
    borderRadius: 20,
    backgroundColor: 'rgba(200,230,210,0.5)',
    padding: 16,
    height: 110,
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
  },
  heroContent: { flex: 1, flexDirection: 'row', alignItems: 'center', zIndex: 2 },
  heroIllustration: { position: 'absolute', right: 5, top: -10 },
  giftBadge: { position: 'absolute', right: 10, top: 15 },
  progressPill: {
    backgroundColor: Colors.primary,
    borderRadius: 20,
    paddingVertical: 8,
    paddingHorizontal: 18,
  },
  progressArrow: { color: '#fff', fontSize: 16, fontWeight: '700' },
  progressBar: {
    flex: 1,
    height: 6,
    backgroundColor: 'rgba(0,0,0,0.1)',
    borderRadius: 3,
    marginLeft: 10,
  },
  progressFill: {
    height: '100%',
    backgroundColor: Colors.primary,
    borderRadius: 3,
  },
  questSection: { paddingHorizontal: 20, marginTop: 16 },
  questTitle: { fontSize: 18, fontWeight: '700', color: Colors.textDark },
  questSubtitle: { fontSize: 13, color: Colors.textMid, marginBottom: 14 },
  claimButton: {
    backgroundColor: Colors.primary,
    paddingVertical: 16,
    borderRadius: 16,
    alignItems: 'center',
    marginTop: 8,
    shadowColor: Colors.primary,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.35,
    shadowRadius: 12,
    elevation: 6,
  },
  claimButtonText: { color: '#fff', fontSize: 17, fontWeight: '700' },
});
